import React from "react";
import "@/App.css";
import "@/styles/SaaleLounge.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import SaaleBeachSection from "@/components/SaaleBeachSection";
import BeachEventsSection from "@/components/BeachEventsSection";
import OpeningHours from "@/components/OpeningHours";
import AboutSection from "@/components/AboutSection";
import MenuSection from "@/components/MenuSection";
import ReservationSection from "@/components/ReservationSection";
import EventsSection from "@/components/EventsSection";
import GallerySection from "@/components/GallerySection";
import BeachGallerySection from "@/components/BeachGallerySection";
import BeachMenuSection from "@/components/BeachMenuSection";
import ContactSection from "@/components/ContactSection";
import ImpressumSection from "@/components/ImpressumSection";
import Footer from "@/components/Footer";
import BeachMenuPage from "@/pages/BeachMenuPage";

const Home = () => {
  return (
    <div className="min-h-screen" style={{ background: '#0A0015' }}>
      <Header />
      <HeroSection />
      <div id="lounge-section">
        <OpeningHours />
        <AboutSection />
        <MenuSection />
        <ReservationSection />
        <EventsSection />
        <GallerySection />
      </div>
      <SaaleBeachSection />
      <BeachMenuSection />
      <BeachEventsSection />
      <BeachGallerySection />
      <ContactSection />
      <ImpressumSection />
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/karte-beach" element={<BeachMenuPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
